function getIndexGirt() {
  const options = document.querySelector(`.product-form__variants`);
  var unit = document.getElementById('swatch-0-metric').checked ?  "Metric" : "Imperial" 
  var fullProductTitle = "";
  fullProductTitle  = fullProductTitle.concat(unit, " \/ " ,selected_coating, " \/ " , selected_holes)
  var currentVariantID;
  for(i = 0; i < options.length; i++) {
       if (options[i].getAttribute("title-value") == fullProductTitle) {
           currentVariantID = options[i].index;
       }
     };
  return currentVariantID;
}

function getWeightGirt() {
  return girtPriceMap.get(girt_title).get(is_metric ? 1 : 0).get(selected_size).get(selected_designation.replaceAll(",", ".")).get("weight");
}

function getVariantIdGirt() {
  return document.querySelector(`.product-form__variants`)[getIndexGirt()].value;
}

if (typeof isGirt === undefined) {
  var isGirt = false;
}

// GIRT function
// Return whether metric input entered is valid or not.
// Uses the bounds determined in the field's min and max attributes.
function validateGirtMetric() {
  let input = document.getElementById('length_input_metric_size-0');
  let error = document.getElementById('metric_size_error');
  let v = parseInt(input.value);
  let min = input.getAttribute('min');
  let max = input.getAttribute('max');
  if (v >= min && v <= max) {
    clearError(error);
    return true;
  } else if (!v) {
    displayError(error, productLengthMissingError);
    return false;
  }
  displayError(error, productLengthOutOfBoundsError);
  return false;
}

// GIRT function
// Return whether imperial input entered is valid or not.
// Uses the bounds determined in the field's min and max attributes.
function validateGirtImperial() {
  let ft_input = document.getElementById('length_input_imperial_feet-0');
  let in_input = document.getElementById('length_input_imperial_inch-0');
  let fr_input = document.getElementById('length_input_imperial_frac-0');
  let error = document.getElementById('imperial_feet_error');
  let v = parseInt(ft_input.value) + ((parseInt(in_input.value) + eval(fr_input.value)) / 12);
  let min = ft_input.getAttribute('min');
  let max = ft_input.getAttribute('max');
  if (v >= min && v <= max) {
    clearError(error);
    return true;
  } else if (!v) {
    displayError(error, productLengthMissingError);
    return false;
  }
  displayError(error, productLengthOutOfBoundsError);
  return false;
}

// GIRT function
// Return whether quantity entered is valid or not.
// Uses the bounds determined in the field's min and max attributes.
function validateGirtQty() {
  let input = is_metric ? document.getElementById('length_input_metric_qty-0') : document.getElementById('length_input_imperial_qty-0');
  let error = is_metric ? document.getElementById('metric_qty_error') : document.getElementById('imperial_qty_error');
  let v = parseInt(input.value);
  let min = input.getAttribute('min');
  if (v >= min) {
    clearError(error);
    return true;
  }
  displayError(error, productQuantityError);
  return false;
}

// GIRT function
// Checks if the price is over the maximum boundary of $10,000
// Returns true is the price is below or equal, false is over $10,000
function validateGirtPrice(price) {
  let error = is_metric ? document.getElementById('metric_qty_error') : document.getElementById('imperial_qty_error');
  if (price > 10000) {
    displayError(error, productOverpriceError);
    return false;
  }
  clearError(error);
  return true;
}

// ==================== Specific logic for girt products ====================
if (isGirt) {
  // Returns selected coating, in english
  function getCoating() {
    return document.getElementById('SingleOptionSelector-1').value;
  }

  // Returns selected holes, in english
  function getHoles() {
    return document.getElementById('SingleOptionSelector-2').value;
  }
  // Fetch sizes and update selects
  let sizes_metric_select = document.getElementById('sizes-select_metric');
  let designations_metric_select = document.getElementById('designation-select_metric');
  let sizes_imperial_select = document.getElementById('sizes-select_imperial');
  let designations_imperial_select = document.getElementById('designation-select_imperial');
  var girt_title = document.getElementById('form_product_name').value;

  let sizes_metric = girtPriceMap.get(girt_title).get(1);
  let sizes_imperial = girtPriceMap.get(girt_title).get(0);

  // Add sizes to select dropdowns
  for (const size of sizes_metric) {
    sizes_metric_select.insertAdjacentHTML("beforeend", "<option>" + size[0] + "</option>");
  }

  for (const size of sizes_imperial) {
    sizes_imperial_select.insertAdjacentHTML("beforeend", "<option>" + size[0] + "</option>");
  }

  var selected_size = is_metric ? sizes_metric_select.value : sizes_imperial_select.value;

  let selected_size_metric = sizes_metric.keys().next().value;
  let designations_metric = sizes_metric.get(selected_size_metric);
  let selected_size_imperial = sizes_imperial.keys().next().value;
  let designations_imperial = sizes_imperial.get(selected_size_imperial);

  // Add designations to select dropdowns
  for (const designation of designations_metric) {
    designations_metric_select.insertAdjacentHTML("beforeend", "<option>" + designation[0] + "</option>");
  }

  for (const designation of designations_imperial) {
    designations_imperial_select.insertAdjacentHTML("beforeend", "<option>" + designation[0] + "</option>");
  }

  var selected_designation = is_metric ? designations_metric_select.value : designations_imperial_select.value;
  var selected_coating = getCoating();
  var selected_holes = getHoles();

  let linear_price = 0.00;

  var mark_number = '';

  function setMarkNumber() {
    mark_number = document.getElementById('mark-number_input').value;
  }

  // Updates user-selected size
  function updateSizes() {
    selected_size = is_metric ? sizes_metric_select.value : sizes_imperial_select.value;
    updateDesignations();
  }

  // Updates designation dropdown list to match user-selected size
  function updateDesignations() {
    if (is_metric) {
	  
      designations_metric = sizes_metric.get(selected_size);
      designations_metric_select.textContent = '';

      for (const designation of designations_metric) {
        designations_metric_select.insertAdjacentHTML("beforeend", "<option>" + designation[0] + "</option>");
      }
    } else {
      designations_imperial = sizes_imperial.get(selected_size);
      designations_imperial_select.textContent = '';
      
      for (const designation of designations_imperial) {
        designations_imperial_select.insertAdjacentHTML("beforeend", "<option>" + designation[0] + "</option>");
      }
    }
  }

  var input_mm = document.getElementById('length_input_metric_size-0');
  var meters = 0.00;
  var lin_m = 0.00;
  var wkg = 0.00;
  var prm = 0.00;
  var prm_u = 0.00;
  var input_qm = document.getElementById('length_input_metric_qty-0');
  
  let w = 0.00;
  let p = 0.00;
  var id = '';
  
  // Updates all metric components and values
  function updateMetric() {
    getVariant();
    meters = input_mm.value / 1000;
    prm_u = p * (meters * 3.281);
    lin_m = meters * input_qm.value;

    wkg = input_qm.value * meters * 3.281 * w / 2.205;

    prm = prm_u * input_qm.value;
    
    updateSummary();
  }

  var input_ft = document.getElementById('length_input_imperial_feet-0');
  var input_in = document.getElementById('length_input_imperial_inch-0');
  var input_fr = document.getElementById('length_input_imperial_frac-0');
  var ft = 0.00;
  var lin_ft = 0.00;
  var wlb = 0.00;
  var pri = 0.00;
  var pri_u = 0.00;
  var input_qi = document.getElementById('length_input_imperial_qty-0');

  // Updates all imperial components and values
  function updateImperial() {
    getVariant();
    ft = (input_ft.value + (input_in.value + (eval(input_fr.value) * 10)) / 12) / 10;
    pri_u = p * ft;
    lin_ft = ft * input_qi.value;

    wlb = lin_ft * w;

    pri = pri_u * input_qi.value;
    
    updateSummary();
  }

  // Updates all selected girt components
  function updateAll() {
    updateSizes();
    updateUnits();
  }

  // Updates user-selected designation and all imperial and metric components and values
  function updateUnits() {
    selected_designation = is_metric ? designations_metric_select.value : designations_imperial_select.value;
    selected_coating = getCoating();
    selected_holes = getHoles();
    setMarkNumber();
    setPriceByLinearFoot();
    updateMetric();
    updateImperial();
  }

  // Returns calculated price by linear foot.  
  // Pricing depends on designation, coating and if standard holes are needed.
  function getPriceByLinearFoot() {
    linear_price = girtPriceMap.get(girt_title).get(is_metric ? 1 : 0).get(selected_size).get(selected_designation).get("price");

    if (selected_holes === 'Yes') {
      linear_price += girtPriceMap.get(girt_title).get('Standard holes');
    }
    if (selected_coating === 'Galvanized ASTM Z90 (G30)') {
      linear_price += girtPriceMap.get(girt_title).get(selected_coating);
    } else if (selected_coating === 'Galvanized ASTM Z275 (G90)') {
      linear_price = linear_price * girtPriceMap.get(girt_title).get(selected_coating);
    }
    return linear_price;
  }

  // Sets the price for the selected girt variant and displays it
  function setPriceByLinearFoot() {
    let price_tag = document.getElementById('product-price');
    let price = getPriceByLinearFoot();
    p = price;
    price_tag.textContent = '';
    price_tag.insertAdjacentHTML("afterbegin", price.toFixed(2));
    if (Shopify.locale === 'fr') {
      price_tag.insertAdjacentHTML("beforeend", '$');
      price_tag.insertAdjacentHTML("beforeend", ' / pi.lin.');
    } else {
      price_tag.insertAdjacentHTML("afterbegin", '$');
      price_tag.insertAdjacentHTML("beforeend", ' / lin.ft.');
    }
  }

  // Displays the footnote is standard holes are required, hide otherwise.
  function displayHolesFootnote() {
    if (document.getElementById('SingleOptionSelector-2').value === "Yes" || document.getElementById('SingleOptionSelector-2').value === "Oui") {
      document.getElementById('holes-footnote').removeAttribute('hidden');
    } else {
      document.getElementById('holes-footnote').setAttribute('hidden', true);
    }
  }

  function getVariant() {
    selected_size = is_metric ? sizes_metric_select.value : sizes_imperial_select.value;
    selected_designation = is_metric ? designations_metric_select.value : designations_imperial_select.value;
    selected_coating = getCoating();
    selected_holes = getHoles();
    w = getWeightGirt();
    id = getVariantIdGirt();
  }

  function updateSummary() {
    document.getElementById('area_m').textContent = lin_m.toFixed(2);
    document.getElementById('weight_m').textContent =  wkg.toFixed(2);
    document.getElementById('summary_price_m').textContent = prm.toFixed(2);
    
    document.getElementById('area_i').textContent = lin_ft.toFixed(2);
    document.getElementById('weight_i').textContent =  wlb.toFixed(2);
    document.getElementById('summary_price_i').textContent = pri.toFixed(2);
    initValidation(pri.toFixed(2) > prm.toFixed(2) ? pri.toFixed(2) : prm.toFixed(2));
  }

  function initValidation(price) {
    let valid = true;
    let button = document.getElementById('addToCart_button');
    if (is_metric) {
        valid = valid && validateGirtMetric();
      } else {
        valid = valid && validateGirtImperial();
      }
    valid = validateGirtQty() && validateGirtPrice(price) && valid;
    isMobile = window.innerWidth <= 600;
    
    if (valid && !isMobile) {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('aria-disabled', true);
        if (!validateGirtPrice(price)) {
          button.setAttribute('disabled', true);
          document.getElementById('metric_qty_error').removeAttribute('hidden');
          document.getElementById('imperial_qty_error').removeAttribute('hidden');
        }
      }
    return valid;
  }

  // >=======================================()-=-=o0o=-=-()=======================================<
  // On PAGE LOAD
  // >=======================================()-=-=o0o=-=-()=======================================<
  function getShippingProvinces(plants) {
    let productProvinces = [];
    for (const plant in plants) {
      Array.prototype.push.apply(productProvinces, provinceByPlant.get(plants[plant]));
    }
    return new Set(productProvinces);
  }

  function hasShipping() {
    let userProvince = getCookieShippingProvince();
    let plants = girtPriceMap.get(girt_title).get('plants');
    let productProvinces = getShippingProvinces(plants);
    return productProvinces.has(userProvince);
  }

  function setShippingWarningBannerMsg() {
    let provinceShort = getCookieShippingProvince();
    let provinceLong = '';
    if (provinceAbbreviationsFR.has(provinceShort)) {
      if (isLocaleFR()) {
        provinceLong = provinceAbbreviationsFR.get(provinceShort);
        document.getElementById('fr-banner__user-province').textContent = provinceLong;
        document.getElementById('fr_phone').textContent = phoneByProvinceFR.get(provinceShort);
      } else {
        provinceLong = provinceAbbreviationsEN.get(provinceShort);
        document.getElementById('en-banner__user-province').textContent = provinceLong;
        document.getElementById('en_phone').textContent = phoneByProvinceEN.get(provinceShort);
      }
    }
  }
  
  var isModified = false;
  var modifiedIndex = '';
  
  window.addEventListener('load', (event) => {
    getVariant();
    if (!getCookieShippingProvince() || hasShipping() || getCookieShippingProvince() === 'None') {
      document.getElementById('shipping-warning-banner').setAttribute('hidden', true);
    } else {
      setShippingWarningBannerMsg();
      document.getElementById('shipping-warning-banner').removeAttribute('hidden');
    }
    setPriceByLinearFoot();
    displayHolesFootnote();
    const propertiesMap = decodeURL();
    if (propertiesMap.size > 0){ 
      fillGirtFields(propertiesMap);
      isModified = true;
      let buttonText = document.getElementById('addToCart_button_text');
      buttonText.textContent = locale === 'fr' ? "Modifier l'item" : "Update product";
    }
  });
  // >=======================================()-=-=o0o=-=-()=======================================<
  // TRIGGERS/EVENT LISTENERS
  // >=======================================()-=-=o0o=-=-()=======================================<

  // Trigger for displaying standard holes footnote
  document.getElementById('SingleOptionSelector-2').addEventListener('change', () => {
    displayHolesFootnote();
  });

  // Trigger for displaying error message wrappers
    document.getElementById('addToCart_button').addEventListener('click', function () {
      document.getElementById('metric_qty_error').removeAttribute('hidden');
      document.getElementById('imperial_qty_error').removeAttribute('hidden');
      document.getElementById('metric_size_error').removeAttribute('hidden');
      document.getElementById('imperial_feet_error').removeAttribute('hidden');
      let valid = initValidation();

      if (valid && isModified) {
        
      }
    });
  
  // >=======================================()-=-=o0o=-=-()=======================================<
  // ON MODIFY
  // >=======================================()-=-=o0o=-=-()=======================================<

  // Fills fields with existing information
  function fillGirtFields(propertiesMap) {
    if (is_metric) {
      document.getElementById('swatch-0-metric').setAttribute('checked', true);
      document.getElementById('swatch-0-imperial').removeAttribute('checked'); // Update swatches
      metricOnClick(); // Update sizes form and summary
      document.getElementById('sizes-select_metric').value = propertiesMap.get('size');
      updateSizes(); // Update designation select dropdown
      document.getElementById('designation-select_metric').value = propertiesMap.get('designation');
      document.getElementById('SingleOptionSelector-1').value = propertiesMap.get('coating');
      document.getElementById('SingleOptionSelector-2').value = propertiesMap.get('holes');
      if (propertiesMap.get("mark_number")) document.getElementById('mark-number_input').value = propertiesMap.get('mark_number');
      document.getElementById('length_input_metric_qty-0').value = propertiesMap.get('quantity');
      document.getElementById('length_input_metric_size-0').value = propertiesMap.get('metric_size');
      updateUnits();
    } else {
      document.getElementById('swatch-0-imperial').setAttribute('checked', true);
      document.getElementById('swatch-0-metric').removeAttribute('checked'); // Update swatches
      imperialOnClick(); // Update sizes form and summary
      document.getElementById('sizes-select_imperial').value = propertiesMap.get('size');
      updateSizes(); // Update designation select dropdown
      document.getElementById('designation-select_imperial').value = propertiesMap.get('designation');
      document.getElementById('SingleOptionSelector-1').value = propertiesMap.get('coating');
      document.getElementById('SingleOptionSelector-2').value = propertiesMap.get('holes');
      if (propertiesMap.get("mark_number")) document.getElementById('mark-number_input').value = propertiesMap.get('mark_number');
      document.getElementById('length_input_imperial_qty-0').value = propertiesMap.get('quantity');
      document.getElementById('length_input_imperial_feet-0').value = propertiesMap.get('feet');
      document.getElementById('length_input_imperial_inch-0').value = propertiesMap.get('inches');
      document.getElementById('length_input_imperial_frac-0').value = propertiesMap.get('fractions');
      updateUnits();
    }
  }
}